interface Icons {
  size: {
    [sizeName: string]: string;
  };
}

const icons: Icons = {
  size: {
    extra: '48px',
    largest: '36px',
    larger: '32px',
    large: '24px',
    medium: '20px',
    small: '16px',
    smallest: '12px',
  },
};

export { icons };
